import HttpRequestService from "./HttpRequestService";

const BlogService = {};

const cntrlName = "GetBlogList";

//API for get all data
BlogService.getBlogList = function () {
  return HttpRequestService.get(cntrlName);
};

BlogService.getBlogById = function (id) {
  return HttpRequestService.get(`${cntrlName}?Id=${id}`);
}

export default BlogService;
